/**
 * Helper to compress/resize remote images (Pexels + Unsplash) on the fly.
 * Both CDNs accept query params that return a much smaller, optimized JPEG.
 *
 * Example reductions for the Hero photo (167605):
 *   original     : 653 KB
 *   w=1600 (CDN) : 110 KB  → -83%
 *   w=800  (CDN) :  40 KB  → -94%
 */
export function optimizeImg(url, w = 1200, q = 70) {
  if (!url) return url;
  const sep = url.includes("?") ? "&" : "?";
  if (url.includes("images.pexels.com")) {
    return `${url}${sep}auto=compress&cs=tinysrgb&w=${w}&dpr=1`;
  }
  if (url.includes("images.unsplash.com")) {
    return `${url}${sep}w=${w}&q=${q}&auto=format&fit=crop`;
  }
  return url;
}

/** Build a responsive srcSet string for the same image at multiple widths. */
export function srcSet(url, widths = [400, 800, 1200, 1600]) {
  return widths.map((w) => `${optimizeImg(url, w)} ${w}w`).join(", ");
}
